<template>
  <apexchart :options="options" :series="series"></apexchart>
</template> 

<script>
import { useViewSelector } from "../../stores/viewSelector";
import { useUserStore } from '../../stores/user';
import { storeToRefs } from 'pinia';
import VueApexCharts from "vue3-apexcharts";
export default{
  name: 'barChart',
  components:{
    apexchart: VueApexCharts,
  },
  setup() {
    const viewSelector = useViewSelector();
    const {currentView} = storeToRefs(viewSelector);
    
    const userStore = useUserStore();
    const {user_id, comp_id, isSessionExpired} = storeToRefs(userStore);
    const {  trigSessVerify } = userStore;

    return {
      user_id,
      comp_id,
      currentView,      
      isSessionExpired,
      trigSessVerify,
    }
  },
  data(){
    return {
      options: {
        chart: {
          type:'bar',
          id: 'vueBarChart',
          stacked: true,
          width:'100%',
        },
        colors:['#7789A4','#0B9719','#BA2D0D'],
        xaxis: {
          type:'datetime',
          categories:[],
        },
        dataLabels:{
          enabled:false,
        },
        title: {
          text: "MRR",
        },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: {
                toolbar: {
                  tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                  }
                },
              },
            }
          }
        ]
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
        },
      },
      noData:{
        text:'Loading...',
      },
      legend: {
        position: 'right',
        offsetY: 40,
      },
      series: [{
            name: 'Old Revenue',
            data: []
          }, {
            name: 'New Revenue',
            data: []
          },
      ],
    }
  },  

  computed: {
    translation: function() {
      return ({
        series: [this.$i18n.t("graphs.bar.series[0]"), this.$i18n.t("graphs.bar.series[1]")],
      })
    }
  },
  watch: {
    translation(t) {
      this.series[0].name = t.series[0];
      this.series[1].name = t.series[1];
    }
  },
  
  mounted() {
    let url = process.env.VUE_APP_URL + '/vintage';
    let nB = {u_id:this.user_id ,c_id:this.comp_id, }
    console.log('nB = '+JSON.stringify(nB))
    fetch(url, {
        method:'POST',
        body:JSON.stringify(nB),
        headers: new Headers({
          "content-type":"application/json"
        })
    })
    .then((res) =>res.json())
    .then((content) => {
      console.table('Vintage');
      console.table(content);
      if(content.invalidSession){
        this.currentView = 'Login';
      }else{
        //Check which revenue monthly_date's bigger Old or New, & use it as categories
        let x = [].concat(...content.vintage[0].chart_data.Old_revenue).map(({monthly_date})=>monthly_date);
        let y = [].concat(...content.vintage[0].chart_data.Old_revenue).map(({value})=>value);
        let z = [].concat(...content.vintage[0].chart_data.New_revenue).map(({value})=>value);
        this.options = {
        ...this.options,
        ...{
            xaxis:{
              categories: x
            }
          }
        }
        this.series[0].data = y;
        this.series[1].data = z;

        this.series[0].name = this.translation.series[0];
        this.series[1].name = this.translation.series[1];
      }
    })
    .catch((err) => {console.log('Erro, '+err)}); 
    
  }, 
}
</script>


<style>
  .wrap {
    display: flex;
    justify-content: center;
}
</style>
